<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import { ModelListSelect } from "vue-search-select";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Expense Categories",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Expense Categories",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Expenses",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "name",
          label: "Name",
          sortable: true,
        },
        {
          key: "items",
          label: "Items",
          sortable: true,
        },
        {
          sortable: false,
          key: "delete",
          label: "Delete Item",
        },
        {
          key: "accounts.acc_name",
          label: "Expense Account",
          sortable: true,
        },
        {
          key: "date",
          label: "Added",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        name: "",
        account: "",
      },
      deleteCat: {
        name: "",
        id: "",
      },
      deleteItem: {
        name: "",
        id: "",
      },
      add: {
        name: "",
        name1: "",
        id: "",
      },
      editCat: {
        account: "",
        name: "",
        id: "",
      },
      existing: [],
      nameError: "",
      accountError: "",
      modal: "",
    };
  },
  computed: {
    ...mapGetters("expenses", ["Categories", "SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    ...mapGetters("accounts", ["getExpenseAccounts"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.Categories ? this.Categories.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Categories ? this.Categories.length : 1;
  },
  methods: {
    ...mapActions({
      FetchCategories: "expenses/fetchExpCategories",
      AddCategory: "expenses/addExpCategory",
      AddItem: "expenses/addExpItem",
      EditCategory: "expenses/editExpCategory",
      DeleteCategory: "expenses/deleteExpCategory",
      DeleteItem: "expenses/deleteExpItem",
      FetchExpenseAccounts: "accounts/fetchExpenseAccounts",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.Categories ? this.Categories.length : 1;
      this.currentPage = 1;
    },

    resetError() {
      this.nameError = "";
      this.accountError = "";
    },

    resetAddModal() {
      this.data.name = "";
      this.resetError();
    },

    checkExist() {
      //when creating a new one
      if (this.data.name != "") {
        this.existing = this.Categories.filter((item) => {
          return item.name.toUpperCase() == this.data.name.toUpperCase();
        });
        if (this.existing.length) {
          this.nameError =
            "Expense Category " + this.data.name + " exists already";
        } else {
          this.nameError = "";
        }
      } else {
        this.existing = [];
      }
    },
    addCategory(modal) {
      if (this.data.name == "") {
        this.nameError = "Category Name field can't be empty";
        return;
      } else {
        this.nameError = "";
      }
      if (this.data.account == "") {
        this.accountError = "Expense Account field can't be empty";
        return;
      } else {
        this.accountError = "";
      }
      if (this.existing.length) {
        this.nameError =
          "Expense Category " + this.data.name + " exists already Please";
        return;
      } else {
        this.nameError = "";
      }
      this.modal = modal;
      this.AddCategory(this.data);
      this.resetError();
      this.resetAddModal();
      this.closeModal(this.modal);
    },
    addItem(modal) {
      if (this.add.name == "") {
        this.nameError = "Expense Item Name field can't be empty";
        return;
      } else {
        this.nameError = "";
      }
      this.modal = modal;
      this.AddItem(this.add);
      this.resetError();
      this.closeModal(this.modal);
    },
    showEditModal(values) {
      this.editCat.id = values.item.id;
      this.editCat.name = values.item.name;
      this.editCat.account = values.item.account;
    },
    showAddModal(values) {
      this.add.id = values.item.id;
      this.add.name1 = values.item.name;
    },
    showDeleteModal(values) {
      this.deleteCat.id = values.item.id;
      this.deleteCat.name = values.item.name;
    },
    showDeleteItemModal(values) {
      this.deleteItem.id = values.id;
      this.deleteItem.name = values.name;
    },
    deleteCategory(modal) {
      this.modal = modal;
      this.DeleteCategory(this.deleteCat);
      this.closeModal(modal);
    },
    deleteCatItem(modal) {
      this.modal = modal;
      this.DeleteItem(this.deleteItem);
      this.closeModal(modal);
    },
    editCategory(modal) {
      if (this.editCat.name == "") {
        this.nameError = "Items field can't be empty";
        return;
      } else {
        this.nameError = "";
      }
      if (!this.editCat.account) {
        this.accountError = "Expense Account field can't be empty";
        return;
      } else {
        this.accountError = "";
      }
      this.modal = modal;
      this.EditCategory(this.editCat);
      this.resetError();
      this.closeModal(this.modal);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchCategories();
    this.FetchExpenseAccounts();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_expense_categories')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">
                  List of Expense Categories
                </h3>
              </div>
              <div class="col-3">
                <button
                  v-b-modal.add-Items-modal
                  v-if="
                    getCurrentUser.permissions.find((item) =>
                      item.permission.includes('add_expense_categories')
                    )
                  "
                  class="btn btn-primary btn-sm float-end"
                >
                  <i class="fa fa-plus"></i> Add New
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="Categories ? Categories : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(items)="data">
                  <table>
                    <tr v-for="(item, index) in data.item.items" :key="index">
                      <td>
                        <h5>{{ item.name }}</h5>
                      </td>
                    </tr>
                  </table>
                </template>
                <template #cell(delete)="data">
                  <table>
                    <tr v-for="(item, index) in data.item.items" :key="index">
                      <td>
                        <button
                          class="btn btn-outline-danger btn-sm"
                          v-b-modal.delete-Item-modal
                          @click="showDeleteItemModal(item)"
                          v-if="
                            getCurrentUser.permissions.find((item) =>
                              item.permission.includes('delete_expense_item')
                            )
                          "
                        >
                          X
                        </button>
                      </td>
                    </tr>
                  </table>
                </template>
                <template #cell(actions)="data">
                  <b-button-group>
                    <button
                      class="btn btn-outline-success btn-sm"
                      v-b-modal.add-Item-modal
                      @click="showAddModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('add_expense_item')
                        )
                      "
                    >
                      <i class="fa fa-plus"></i> Add
                    </button>
                    <button
                      class="btn btn-outline-primary btn-sm"
                      v-b-modal.edit-Items-modal
                      @click="showEditModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('edit_expense_categories')
                        )
                      "
                    >
                      <i class="fa fa-edit"></i> Edit
                    </button>
                    <button
                      class="btn btn-outline-danger btn-sm"
                      v-b-modal.delete-Items-modal
                      @click="showDeleteModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('delete_expense_categories')
                        )
                      "
                    >
                      <i class="fa fa-trash"></i> Delete
                    </button>
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- modal starts -->
      <b-modal
        id="add-Items-modal"
        hide-footer
        @hidden="resetAddModal"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_expense_categories')
          )
        "
      >
        <template #modal-title> Add New Expense Category </template>
        <div class="form-group mb-3">
          <label>Category Name</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Enter Expense Category Name"
              class="form-control"
              @keyup="checkExist"
              @input="resetError"
              v-model="data.name"
            />
          </div>
          <div class="text-danger" v-if="nameError">
            <em>{{ nameError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Expense Account</label>
          <div class="input-group">
            <model-list-select
              required
              :list="getExpenseAccounts ? getExpenseAccounts : []"
              v-model="data.account"
              option-value="id"
              option-text="full_name"
              class="mb-2"
              placeholder="Select Account"
            >
            </model-list-select>
          </div>
          <div class="text-danger" v-if="accountError">
            <em>{{ accountError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('add-Items-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-outline-primary"
            @click="addCategory('add-Items-modal')"
          >
            <i class="fa fa-check"></i>
            Submit
            <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Spinning"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
      <!-- modal starts -->
      <b-modal id="add-Item-modal" hide-footer>
        <template #modal-title>
          Add New Expense Item Under
          <small
            ><em>{{ add.name1 }}</em></small
          ></template
        >
        <div class="form-group mb-3">
          <label>Item Name</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Enter Expense Item Name"
              class="form-control"
              @keyup="checkExist"
              @input="resetError"
              v-model="add.name"
            />
          </div>
          <div class="text-danger" v-if="nameError">
            <em>{{ nameError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('add-Item-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-outline-primary"
            @click="addItem('add-Item-modal')"
          >
            <i class="fa fa-check"></i>
            Submit
            <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Spinning"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
      <!-- edit modal starts -->
      <b-modal
        id="edit-Items-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('edit_expense_categories')
          )
        "
      >
        <template #modal-title>
          Edit Expense Categories {{ editCat.name }}</template
        >
        <div class="form-group mb-3">
          <label>Category Name</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              @input="resetError"
              v-model="editCat.name"
            />
          </div>
          <div class="text-danger" v-if="nameError">
            <em>{{ nameError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Expense Account</label>
          <div class="input-group">
            <model-list-select
              required
              :list="getExpenseAccounts ? getExpenseAccounts : []"
              v-model="editCat.account"
              option-value="id"
              option-text="full_name"
              class="mb-2"
              placeholder="Select Account"
            >
            </model-list-select>
          </div>
          <div class="text-danger" v-if="accountError">
            <em>{{ accountError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('edit-Items-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-outline-primary"
            @click="editCategory('edit-Items-modal')"
          >
            <i class="fa fa-check"></i>
            Save Changes</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Saving"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete Items starts -->
      <b-modal
        id="delete-Items-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_expense_categories')
          )
        "
      >
        <template #modal-title>
          <h4 class="text-danger">
            Delete Expense Category {{ deleteCat.name }}
          </h4></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h5>
              Do you want to delete Expense Category {{ deleteCat.name }}? Click
              Proceed Button to delete.
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-Items-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-outline-danger"
            @click="deleteCategory('delete-Items-modal')"
          >
            <i class="fa fa-trash"></i> Confirm</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->
      <!-- modal delete Items starts -->
      <b-modal
        id="delete-Item-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_expense_item')
          )
        "
      >
        <template #modal-title>
          <h4 class="text-danger">
            Delete Expense Item {{ deleteItem.name }}
          </h4></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h5>
              Do you want to delete Expense Item {{ deleteItem.name }}? Click
              Proceed Button to delete.
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-Item-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-outline-danger"
            @click="deleteCatItem('delete-Item-modal')"
          >
            <i class="fa fa-trash"></i> Confirm</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
